import PropTypes from 'prop-types';
import { CouponDiscountTypes } from '../enums/coupon-discount-type';
import { CouponTemporalUnits } from '../enums/coupon-temporal-unit';

export const CouponPropType = PropTypes.shape({
  appliesForMonths: PropTypes.number,
  discountInCents: PropTypes.number,
  discountPercent: PropTypes.number,
  discountType: PropTypes.oneOf(CouponDiscountTypes),
  freeTrialAmount: PropTypes.number,
  freeTrialUnit: PropTypes.oneOf(CouponTemporalUnits),
  hostedDescription: PropTypes.string,
  invoiceDescription: PropTypes.string,
  name: PropTypes.string,
  isAppliedToInvoice: PropTypes.bool,
});

/**
 * @typedef {object} CouponPropType
 * @property {number} appliesForMonths
 * @property {number} discountInCents
 * @property {number} discountPercent
 * @property {('Percent'|'Dollar'|'FreeTrial')} discountType
 * @property {number} freeTrialAmount
 * @property {('Day'|'Week'|'Month'|'Year')} freeTrialUnit
 * @property {string} hostedDescription
 * @property {string} invoiceDescription
 * @property {string} name
 * @property {boolean} isAppliedToInvoice
 */
